<script>
import AiAnalysis from "@/components/InvestigationEngine/AiAnalysis.vue";
import CheckRenderer from "@/components/InvestigationEngine/CheckRenderer.vue";

export default {
    components: {
        AiAnalysis,
        CheckRenderer,
    },

    props: {
        serial: {
            type: String,
            required: true,
        },
        deviceType: {
            type: String,
            default: '',
        },
        initialResults: {
            type: Array,
            required: true,
        },
    },

    provide() {
        return {
            onCheckComplete: this.handleCheckComplete,
        };
    },

    data() {
        const pending = this.initialResults.filter(r => r.status === 'pending');

        return {
            checkResults: this.initialResults.map(r => ({ ...r })),
            pendingCount: pending.length,
            completedCount: 0,
        };
    },

    computed: {
        allChecksReady() {
            return this.pendingCount === 0 || this.completedCount >= this.pendingCount;
        },
    },

    methods: {
        handleCheckComplete(resolved) {
            const idx = this.checkResults.findIndex(r =>
                r.id === resolved.id
                && (r.meter_serial ?? null) === (resolved.meter_serial ?? null)
            );

            if (idx !== -1) {
                this.checkResults[idx] = {
                    ...this.checkResults[idx],
                    status: resolved.status,
                    data: resolved.data,
                    error: resolved.error,
                };
            }

            this.completedCount += 1;
        },
    },
};
</script>

<template>
    <div class="flex flex-col gap-8">
        <div class="rounded-md border border-gray-200 bg-white p-4">
            <ai-analysis
                :serial="serial"
                :device-type="deviceType"
                :results="checkResults"
                :checks-ready="allChecksReady"
            />
        </div>

        <div
            v-for="(result, idx) in initialResults"
            :key="`${result.id}-${result.meter_serial ?? idx}`"
            class="rounded-md border border-gray-200 bg-white p-4"
        >
            <check-renderer :serial="serial" :result="result" />
        </div>
    </div>
</template>
